<template>
  <Multiselect
    class="filter-multiselect"
    v-else
    @input="change"
    track-by="filter"
    group-label="group"
    :searchable="true"
    :value="inputFilter"
    label="description"
    :options="_filters"
    :show-labels="false"
    group-values="items"
    open-direction="bottom"
    :preselect-first="true"
    :internal-search="true"
    :show-no-options="false"
    :placeholder="__('Selecione o filtro')"
  />
</template>

<script>
/**
   * Array of filters that cannot repeat
   */
const uniques = [
  'tag',
  'mail.opened',
  'mail.clicked',
  'mail.delivered',
  'mail.not.opened',
  'mail.all.opened',
  'mail.any.opened',
  'mail.any.clicked',
  'mail.not.clicked',
  'leads.email.empty',
  'mail.not.delivered',
  'mail.any.opened.90',
  'mail.any.opened.30',
  'mail.any.opened.10',
  'mail.any.clicked.90',
  'mail.any.clicked.30',
  'mail.any.clicked.10',
  'mail_status->invalid',
  'mail.delivered.not.opened',
];

export default {
  props: ['filters', 'removedFilters', 'value', 'rows'],

  mounted () {
    this.inputFilter = this.getFilter(this.value);

    this.selected = this.rows || [];
  },

  data: () => ({
    inputFilter: '',
    selected: [
      //
    ],
  }),

  watch: {
    value (input) {
      this.inputFilter = this.getFilter(this.value);
    },
  },

  computed: {
    _filters () {
      return Object.values(this.filters.reduce((filters, { type, filter, description }) => {
        const group = type || 'Campos Customizados';

        if (! filters[group]) {
          filters[group] = {
            group,
            items: [
              //
            ],
          };
        }

        filters[group].items.push({
          filter,
          description,
          $isDisabled: this.isDisabled(filter, this.selected),
        });

        return filters;
      }, {
        //
      }));
    },
  },

  methods: {
    isDisabled (filter, selected) {
      if (! uniques.includes(filter) || selected.length === 0) {
        return;
      }

      const rows = selected.filter(
        (row) => row.filter === filter,
      );

      return rows.length > 1;
    },

    getFilter (filter) {
      return this.filters.find((object) => object.filter.toString() === filter.toString())
          || this.removedFilters.find((object) => object.filter.toString() === filter.toString());
    },

    change (value) {
      const filter = this.getFilter(value.filter);

      Bus.$emit('filterChanged', filter, this.inputFilter || {});

      this.$emit('input', filter.filter);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../sass/variables';

  .filter-multiselect {
    &.multiselect::v-deep {
      background-color: $white;
      color: $gray-dark !important;

      .multiselect__tags {
        .multiselect__single {
          color: $salesflow-font-dark !important;
        }

        .multiselect__input {
          &::placeholder {
            color: $gray-light;
          }
        }

        .multiselect__option--active {
          color: blue;
        }
      }
    }
  }
</style>
